// In production (Vercel): REACT_APP_API_URL=/api  (proxied via vercel.json → Railway)
// In local dev:           REACT_APP_API_URL=http://localhost:8000/api
export const API_URL   = process.env.REACT_APP_API_URL   || 'http://localhost:8000/api';
export const MEDIA_URL = process.env.REACT_APP_MEDIA_URL || 'http://localhost:8000/media';

export const CATEGORIES = {
  "History, Places & Leadership": [
    "Past and departed heroes & heroines",
    "Progressive honorary chiefs",
    "Political figures & local government chairmen",
    "National award recipients",
    "Historical villages, towns, rivers, and settlements"
  ],
  "Education & Academia": [
    "Professors (living & past)",
    "Doctorate holders (PhD)",
    "School principals",
    "Social scientists, arts & education experts",
    "Agricultural & food science researchers"
  ],
  "Health, Law & Public Service": [
    "Medical doctors, nurses, pharmacists",
    "Physiotherapists & health specialists",
    "Judges, justices, barristers",
    "Civil servants & government agency leaders"
  ],
  "Business & Professions": [
    "Business owners & entrepreneurs",
    "Bankers, accountants, insurers",
    "Engineers, architects, surveyors, geologists",
    "Transport owners, petrol station owners",
    "Hotels, bars, event centres, bukas, markets"
  ],
  "Sports, Media & Technology": [
    "Footballers, coaches, sports men & women",
    "Journalists, columnists",
    "Nollywood actors & creatives",
    "Photographers, cinematographers",
    "Computer scientists, IT professionals, technologists"
  ]
};

export const ARCHIVE_SECTIONS = [
  { id: 1, category: "History, Places & Leadership", title: "Our Identity, Legacy, and Governance", description: "Preserving our history and cultural memory", icon: "🏛️", tags: ["history","politics","places"] },
  { id: 2, category: "Education & Academia", title: "Our Intellectual and Academic Excellence", description: "Inspiring students and promoting learning pathways.", icon: "🎓", tags: ["education","students","school"] },
  { id: 3, category: "Health, Law & Public Service", title: "Our Professionals Serving Society", description: "Recognizing service and building trust in institutions.", icon: "⚕️", tags: ["health","law","public service"] },
  { id: 4, category: "Business & Professions", title: "Our Economic Drivers and Skilled Professionals", description: "Showcasing economic strength and job pathways.", icon: "💼", tags: ["business","bankers","workers"] },
  { id: 5, category: "Sports, Media & Technology", title: "Modern Influence, Culture, and Innovation", description: "Highlighting talents, creativity, and future-ready skills.", icon: "🚀", tags: ["IT","entertainment","creative"] },
];

export const slugify = (str) =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const deslugify = (slug, map) =>
  Object.keys(map).find(k => slugify(k) === slug) || slug;
